import flagsmith from "flagsmith";

export const shoulduseYieldV2ForHotel = (hotelId: number): boolean => {
  const hotelIdsString = flagsmith.getValue("new_backend_beta") as string;
  if (!hotelIdsString || typeof hotelIdsString !== "string") return false;

  const hotelIds = hotelIdsString
    .split(",")
    .map((id) => parseInt(id.trim(), 10));
  return hotelIds.includes(hotelId);
};
